<template>
<div>
    <Breadcrumbs main="Admin" submain="About" title="Involvement" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Image</label>
                                        <div>
                                            <img v-if="show_image" style="width: 160px; border-radius: 6px;" :src="show_image">
                                            <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadImage">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <h6>Involvement 1</h6>

                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Value</label>
                                                    <input class="form-control" type="number" v-model="involvement.involvement1.count" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Suffix</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement1.suffix" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Title</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement1.organization" placeholder="Enter title" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Description</label>
                                                    <b-form-textarea class="form-control" type="text" v-model="involvement.involvement1.description" placeholder="Enter description" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <h6>Involvement 2</h6>

                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Value</label>
                                                    <input class="form-control" type="number" v-model="involvement.involvement2.count" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Suffix</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement2.suffix" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Title</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement2.organization" placeholder="Enter title" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Description</label>
                                                    <b-form-textarea class="form-control" type="text" v-model="involvement.involvement2.description" placeholder="Enter description" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <h6>Involvement 3</h6>

                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Value</label>
                                                    <input class="form-control" type="number" v-model="involvement.involvement3.count" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Suffix</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement3.suffix" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Title</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement3.organization" placeholder="Enter title" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Description</label>
                                                    <b-form-textarea class="form-control" type="text" v-model="involvement.involvement3.description" placeholder="Enter description" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <h6>Involvement 4</h6>

                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Value</label>
                                                    <input class="form-control" type="number" v-model="involvement.involvement4.count" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Suffix</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement4.suffix" placeholder="Enter value" />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label>Title</label>
                                                    <input class="form-control" type="text" v-model="involvement.involvement4.organization" placeholder="Enter title" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Description</label>
                                                    <b-form-textarea class="form-control" type="text" v-model="involvement.involvement4.description" placeholder="Enter description" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <b-button @click="handleSubmit">Submit</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Container-fluid Ends-->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    myHost
} from '../../../_helpers/host';
import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            involvement: {
                image: null,
                involvement1: {
                    count: null,
                    suffix: null,
                    organization: null,
                    description: null
                },
                involvement2: {
                    count: null,
                    suffix: null,
                    organization: null,
                    description: null
                },
                involvement3: {
                    count: null,
                    suffix: null,
                    organization: null,
                    description: null
                },
                involvement4: {
                    count: null,
                    suffix: null,
                    organization: null,
                    description: null
                }
            },
            show_image: null
        };
    },

    computed: {
        ...mapState({
            new_involvement: state => state.about.involvement,
            loading: state => state.about.involvementLoading,
            error: state => state.about.involvementError
        })
    },

    watch: {
        new_involvement(oldValue, newValue) {
            this.involvement.involvement1 = this.new_involvement.involvement1
            this.involvement.involvement2 = this.new_involvement.involvement2
            this.involvement.involvement3 = this.new_involvement.involvement3
            this.involvement.involvement4 = this.new_involvement.involvement4
            this.show_image = this.host + this.new_involvement.image
        }
    },

    mounted() {
        this.$store.dispatch("about/fetchInvolvement")
    },

    methods: {
        uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.involvement.image = e.target.result
                this.show_image = e.target.result
            };
        },

        handleSubmit() {
            console.log(this.involvement);
            this.$store.dispatch("about/addInvolvement", this.involvement).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
